(function () {

    'use strict';

    angular
        .module('corporateRoleEditModule')
        .controller('CorporateRoleAddController', Controller);

    Controller.$inject = ['$scope', 'topBarService'];

    function Controller($scope, topBarService) {
            
        topBarService.setTitleAndIcon('New Corporate Role', 'fa fa-tags');
        $scope.corporateRole = {};

    }
})();